import { Box, Typography, styled } from '@mui/material';

export const CALENDAR_COLUMNS_TEMPLATE = 'repeat(7, minmax(0, 1fr))';
export const CALENDAR_HEADER_HEIGHT = '50px';

export const CalendarHeaderRow = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: CALENDAR_COLUMNS_TEMPLATE,
  height: CALENDAR_HEADER_HEIGHT,
  width: '100%',
  flexShrink: 0,
  boxSizing: 'border-box',
}));

export const DayHeaderCell = styled(Box)(() => ({
  display: 'flex',
  boxSizing: 'border-box',
  padding: '10px',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  justifySelf: 'stretch',
  background: '#FFF',
}));

export const DayHeaderText = styled(Typography)(() => ({
  color: 'var(--Typography-h-secondary, #504E5A)',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '120%',
  textTransform: 'capitalize',
}));
